module.exports = __webpack_public_path__ + "img/huoli15.9941b5d5.png";